var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueSelect',{attrs:{"options":_vm.options,"multiple":_vm.multiple,"value":_vm.value,"filterable":false,"reduce":_vm.reduce,"label":"name"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }